/**
 * Estado de conexion del navegador.
 *
 * `navigator.onLine` es **orientativo**: dice si hay interfaz de red, no si el servidor
 * responde. Por eso solo se usa para adelantar un aviso ("parece que estas sin
 * conexion") y nunca para bloquear un envio. Quien decide si la operacion se hizo es la
 * respuesta del servidor, o su ausencia (`RED_NO_DISPONIBLE`).
 */

import { useSyncExternalStore } from 'react';

function suscribir(alCambiar: () => void): () => void {
  window.addEventListener('online', alCambiar);
  window.addEventListener('offline', alCambiar);
  return () => {
    window.removeEventListener('online', alCambiar);
    window.removeEventListener('offline', alCambiar);
  };
}

function leer(): boolean {
  return navigator.onLine;
}

/** `true` cuando el navegador cree tener conexion. En el servidor, siempre `true`. */
export function useEstaEnLinea(): boolean {
  return useSyncExternalStore(suscribir, leer, () => true);
}
